import { useState } from 'react'
import { Box, styled } from '@mui/material'
import i18next from 'i18next'
import { TimePicker } from '@web-lite/scroll-picker'
import { BottomDrawer } from '$common/bottom-drawer'
import { SettingsSection } from '$common/settings-section'
import { useIsDesktopSize } from '$common/react-hooks/layout'
import { SecondaryButton } from '$common/buttons'
import { clampDate } from '$comp/modals/date-picker/date-picker.helper'
import { t } from '$i18n'

const Container = styled(Box)`
  padding: 0 20px 20px;
  width: 100%;
  box-sizing: border-box;
`

type ChildrenProps = Parameters<typeof TimePicker>[0]

interface Props {
  Children: (props: ChildrenProps) => JSX.Element
  headerText: string
  onConfirm: (value: unknown) => unknown
  onClose: () => unknown
  defaultValue: Date
  start: Date
  end: Date
  isOpen: boolean
}

export function DatePickerModal({
  Children,
  headerText,
  onConfirm,
  onClose,
  defaultValue,
  start,
  end,
  isOpen,
}: Props) {
  const isDesktop = useIsDesktopSize()
  const [value, setValue] = useState<Date>()

  return (
    <BottomDrawer isOpen={isOpen} onClose={onClose}>
      <SettingsSection
        headerText={headerText}
        sx={isDesktop ? { marginBottom: 0 } : null}
      >
        <Container>
          <Children
            locale={i18next.language}
            onChange={date => {
              setValue(clampDate(start, end, date))
            }}
            theme={null}
            end={end}
            selected={defaultValue}
            start={start}
          />

          <SecondaryButton
            text={t('common.confirm')}
            onClick={() => {
              onClose()
              onConfirm(value)
            }}
            sx={{ width: '100%', marginTop: '20px' }}
          />
        </Container>
      </SettingsSection>
    </BottomDrawer>
  )
}
